import { ConditionalRenderer } from '@cian/conditional-component';
import { NoSsr } from '@cian/react-utils';
import { Hydrate, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import * as React from 'react';
import { ReactNode } from 'react';

import { IServerSideState } from '../../types/serverSideState';

export interface IServerSideStateProviderProps {
  serverSideState: IServerSideState;
  children: ReactNode;
}

export const ServerSideStateProvider: React.VFC<IServerSideStateProviderProps> = props => {
  const {
    serverSideState: { queryClient, dehydratedState },
    children,
  } = props;

  const shouldShowDevTools = React.useMemo(() => {
    return process.env.NODE_ENV === 'development' && typeof window !== 'undefined' && !('Cypress' in window);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Hydrate state={dehydratedState}>{children}</Hydrate>
      <NoSsr>
        <ConditionalRenderer if={shouldShowDevTools}>
          <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
        </ConditionalRenderer>
      </NoSsr>
    </QueryClientProvider>
  );
};
